import React from "react";
import { Card } from 'reactstrap';
import Background from './bg';

const getDaysAgo = (days) => {
  const today = new Date(); // Current date and time
  const sevenDaysAgo = new Date(today); // Clone the current date
  sevenDaysAgo.setDate(today.getDate() - days); // Subtract 7 days

  // Set to start of the day (midnight)
  sevenDaysAgo.setHours(0, 0, 0, 0);

  return sevenDaysAgo;
};

const InsightsCard = ({ data, loading }) => {

  if (loading) {
    return <React.Fragment />;
  }

  const currentRangeStart = new Date(getDaysAgo(7)).getTime();
  const previousRangeStart = new Date(getDaysAgo(14)).getTime();

  let currentTotal = 0;
  let previousTotal = 0;

  for (const item of data) {
    const itemTime = new Date(item.item_date).getTime();

    if (itemTime >= previousRangeStart && itemTime < currentRangeStart) {
      previousTotal += item.item_total;
    }

    if (itemTime >= currentRangeStart) {
      currentTotal += item.item_total;
    }
  }

  if (currentTotal === 0 || previousTotal === 0) {
    return <React.Fragment />;
  }

  const itemValue = (((currentTotal / previousTotal) - 1) * 100);

  const upClass = 'from-purple-800 via-purple-800 to-purple-700';
  const downClass = 'from-purple-800 via-purple-800 to-purple-700';

  return (
    <Card 
      className={`bg-gradient-to-r ${ itemValue > 0 ? upClass : downClass } text-white mb-2 relative overflow-hidden rounded-tr-2xl rounded-bl-2xl`}
    >
      <Background className="absolute top-0 left-0 w-100 h-100" opacity={0.05} />
      <div className="absolute top-0 right-0 border-l border-b border-white bg-violet-900 rounded-bl-lg px-4 py-1 font-thin">Insights</div>
      <div className="relative z-10 h-100 p-7">
        <p className="sm:text-sm xl:text-lg font-thin leading-tight w-100 pr-[70px]">
          Your 7 Day Processing Volume <br />has { itemValue > 0 ? 'increased' : 'decreased' } by <strong className='font-bold'>{itemValue.toFixed(2)}%</strong>
        </p>
      </div>
    </Card>
  );
};

export default InsightsCard;
